import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@material-ui/core'
import React, { useState } from 'react'

interface Props {
  open: boolean
  onAccept: (file: string) => void
  onReject: () => void
}

const UploadInvoiceModal: React.FC<Props> = ({ open, onReject, onAccept }) => {
  const [file, setFile] = useState('')
  return (
    <Dialog
      open={open}
      onClose={onReject}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Carga la cuenta de cobro firmada</DialogTitle>
      <DialogContent>
        <p>La cuenta de cobro debe ser firmada y adjuntada aquí:</p>
        <TextField
          label="URL a cuenta de cobro"
          variant="outlined"
          margin="normal"
          onChange={event => setFile(event.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={() => onAccept(file)} color="primary" variant="contained" disabled={file?.length <= 6}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UploadInvoiceModal
